import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { WriteupsService } from 'src/app/feature/writeups-leads/services/writeups.service';
import { WriteupsDetailService } from 'src/app/feature/writeups-detail/services/writeups-details.service';
import * as appCustomerInfoActions from '../actions/customer-info.action';
@Injectable()
export class GetDealDetailsForInitiatedModalEffects {

  public getDealDetailsForInitiatedModal: Observable<Action> = createEffect(() => this._actions.pipe(
    ofType(appCustomerInfoActions.GetDealDetailsForInitiatedModalAction),
    switchMap((action) => {
      return this._writeupsService
        .getDealDetailsForInitiatedModal(action.payload)
        .pipe(map((response) => appCustomerInfoActions.GetDealDetailsForInitiatedModalSucessAction({ response })),
          catchError(error => of(appCustomerInfoActions.GetDealDetailsForInitiatedModalFailAction({ error })))
        );
    })
  ));

    
    public getVehicleDetailsForInitiatedModal:Observable<Action> = createEffect(() => this._actions.pipe(
      ofType(appCustomerInfoActions.GetVehicleDetailsForInitiatedModalAction),
      switchMap((action) => {
        return this._writeupsService
          .getVehicleDetailsForInitiatedModal(action.payload)
          .pipe(map((response) => appCustomerInfoActions.GetVehicleDetailsForInitiatedModalSucessAction({ response })),
            catchError(error => of(appCustomerInfoActions.GetVehicleDetailsForInitiatedModalFailAction({ error })))
          );
      })
    ));

    
    public getPaymentDetailsForInitiatedModal:Observable<Action> = createEffect(() => this._actions.pipe(
      ofType(appCustomerInfoActions.GetRebateDetailsForInitiatedModalAction),
      switchMap((action) => {
        return this._writeupsDetailService
          .getIncentiveId(action.payload)
          .pipe(map((response) => appCustomerInfoActions.GetRebateDetailsForInitiatedModalSucessAction({ response })),
            catchError(error => of(appCustomerInfoActions.GetRebateDetailsForInitiatedModalFailAction({ error })))
          );
      })
    ));

    
    public getCustomerDetails:Observable<Action> = createEffect(() => this._actions.pipe(
      ofType(appCustomerInfoActions.GetCustomerDetailsAction),
      switchMap(() => {
        return this._writeupsService
          .getCustomerDetails()
          .pipe(map((response) => appCustomerInfoActions.GetCustomerDetailsSuccessAction({ response })),
            catchError(error => of(appCustomerInfoActions.GetCustomerDetailsFailAction({ error })))
          );
      })
    ));

    
    public getPaymentDetails:Observable<Action> = createEffect(() => this._actions.pipe(
      ofType(appCustomerInfoActions.GetPaymentDetailsAction),
      switchMap((action) => {
        return this._writeupsService
          .getPaymentDetails(action.payload)
          .pipe(map((response) => appCustomerInfoActions.GetPaymentDetailsSuccessAction({ response })),
            catchError(error => of(appCustomerInfoActions.GetPaymentDetailsFailAction({ error })))
          );
      })
    ));



    
  constructor(
    private _actions: Actions,
    private _writeupsService: WriteupsService,
    private _writeupsDetailService: WriteupsDetailService,
    // private protectionProductService: ProtectionProductService,

  ) {}
}